import React, {useState} from 'react'
import { connect } from 'react-redux'

import { ReactComponent as Trigger } from 'images/icons/filter.svg'

import {Container, ModeContainer, OptionList} from './styled.js'

const TableFilter = (props) => {
    const {t, data} = props
    
    const {right=false} = props
    const [filter, setFilter] = useState({
        mode: null,
        option: data.header[0].key
    })
    const [showFilter, setShowFilter] = useState(false)

    const handleClickAway = () => {

    }

    const handleSetFilter = (attr, value) => {
        switch (attr) {
            case 'mode':
                setFilter(prev => ({
                    ...prev,
                    mode: value
                }))
                break;
            case 'option':
                setFilter(prev => ({
                    ...prev,
                    option: value
                }))
                
                break;
        }

        props.handleFilter = filter
    }
    
    return <>
        <Trigger onClick={() => setShowFilter(showFilter===true?false:true)}/>
        {showFilter && <Container right={right}>
            <h1>{t.title}</h1>
            <ModeContainer>
                <button onClick={() => handleSetFilter('mode', 'growing')}>{t.growing}</button>
                <button onClick={() => handleSetFilter('mode', 'decreasing')}>{t.decreasing}</button>
            </ModeContainer>
            <OptionList>
                {data.header.map((v,i) => <button key={i} onClick={() => handleSetFilter('option', v.key)}>{v.key}</button>)}
            </OptionList>
        </Container>}
    </>
}

const mapStateToProps = state => ({
    t: state.i18nState.translations[state.i18nState.lang]["Filter"]
})

export default connect(mapStateToProps)(TableFilter)